import { Injectable, Injector } from '@angular/core';
import { UrlRequestService } from '../../cross-team-shared/misc-services/resources/url-request.service';
import { TokenManagementService } from '../../cross-team-shared/misc-services/token-management.service';
import {
  SampleTask,
  SamplingPortalTaskContext,
} from '../../team-apis/otterdam/sample-task';
import { QaFeedback } from '../../team-apis/otterdam/task';
import { updateTaskScorePath } from '../misc-utilities/sampling-portal-paths';

interface SubmitQaFeedbackOptions {
  step_id: number;
  submission_id: number;
  projectId: number;
  taskId: string;
  qaFeedback: QaFeedback;
  round: number;
  context: SamplingPortalTaskContext;
}

@Injectable({ providedIn: 'root' })
export class SamplingPortalResource extends UrlRequestService {
  constructor(
    injector: Injector,
    private tokenService: TokenManagementService,
  ) {
    super(injector);
  }

  async updateScoreFromSampleTask(attrs: {
    submissionId: number;
    stepId: number;
    projectId: number;
    taskId: string;
    round: number;
    context: SamplingPortalTaskContext;
    sampleTask: SampleTask;
    sampleId: number;
  }): Promise<QaFeedback> {
    const feedbackToSave: QaFeedback = {
      comment: attrs.sampleTask.comment,
      sample_task_id: attrs.sampleTask.id,
      sampleId: attrs.sampleId,
    };

    return this.submitQaFeedbackSampling({
      step_id: attrs.stepId,
      submission_id: attrs.submissionId,
      projectId: attrs.projectId,
      taskId: attrs.taskId,
      round: attrs.round,
      context: attrs.context,
      qaFeedback: feedbackToSave,
    });
  }

  async submitQaFeedbackSampling(qaOptions: SubmitQaFeedbackOptions) {
    const path = updateTaskScorePath(
      qaOptions.projectId,
      qaOptions.taskId,
      qaOptions.round,
      qaOptions.context,
    );

    const headers = await this.buildRequestOptions();
    return this.request<QaFeedback>('POST', path, {
      ...headers,
      body: {
        step_id: qaOptions.step_id,
        submission_id: qaOptions.submission_id,
        ...qaOptions.qaFeedback,
      },
      retryCount: 5,
    });
  }

  private async buildRequestOptions() {
    const token = await this.tokenService.getToken('access_token');
    return { headers: { Authorization: 'Bearer ' + token } };
  }
}
